<template>
  <div id="app">
    <router-view
      v-if="['wxjobchance', 'wxjobDetails',  'zxjobchance', 'zxjobDetails'].includes($route.name)"
      style="flex:1;display: flex;"
    />
    <template v-else>
      <Header></Header>
      <router-view style="flex:1;display: flex;" />
      <Footer></Footer>
    </template>
  </div>
</template>

<script>
export default {
  name: "App"
};
</script>

<style scoped>
#app {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
}
</style>



// WEBPACK FOOTER //
// src/App.vue